
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';

export const relationSettingsAddressesConfig = {
    all:  {
        title: 'addresses',
        subtitle: 'addresses',
        icon: <ContactMailOutlinedIcon/>,
    },
};
